"use client";

import * as React from "react";

export function AccountProfileStateHarness() {
  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const state = params.get("state");
    if (!state) return;

    const triggerWhenReady = (label: string, attempts = 30) => {
      const tick = (n: number) => {
        const el = document.querySelector<HTMLElement>(
          `[aria-label="${label}"]`,
        );
        if (el) {
          el.click();
          return;
        }
        if (n > 0) setTimeout(() => tick(n - 1), 100);
      };
      tick(attempts);
    };

    const setLinkedIn = (connected: boolean) => {
      window.dispatchEvent(
        new CustomEvent("account-profile:set-linkedin", {
          detail: { connected },
        }),
      );
    };

    const run = () => {
      switch (state) {
        case "linkedin":
          setLinkedIn(true);
          break;
        case "cancel-linkedin":
          setLinkedIn(true);
          triggerWhenReady("取消綁定 LinkedIn");
          break;
        case "password":
          triggerWhenReady("更改密碼");
          break;
      }
    };
    setTimeout(run, 100);
  }, []);
  return null;
}
